// extracted by mini-css-extract-plugin
export var container = "_n8-0";
export var dotAnimation = "_n8-2";
export var dotsLoading = "_n8-1";